<template>
  <div class="subscription-list mb-5 mx-3">
    <h1 class="mb-3">Billing</h1>
    <!-- Tabs -->
    <nav class="navbar navbar-expand primary-tab-bar">
      <ul class="navbar-nav mb-lg-0">
        <li class="nav-item">
          <a
            class="nav-link d-flex flex-nowrap primary-tab"
            :class="{ 'primary-tab-active': activeTab === 'proposals' }"
            href="#"
            @click.prevent="switchTab('proposals')"
          ><span>Proposals</span></a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link d-flex flex-nowrap primary-tab"
            :class="{ 'primary-tab-active': activeTab === 'subscriptions' }"
            href="#"
            @click.prevent="switchTab('subscriptions')"
          ><span>Subscriptions</span></a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link d-flex flex-nowrap primary-tab"
            :class="{ 'primary-tab-active': activeTab === 'invoices' }"
            href="#"
            @click.prevent="switchTab('invoices')"
          ><span>Upcoming Invoices</span></a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link d-flex flex-nowrap primary-tab"
            :class="{ 'primary-tab-active': activeTab === 'past_invoices' }"
            href="#"
            @click.prevent="switchTab('past_invoices')"
          ><span>Past Invoices</span></a>
        </li>
      </ul>
    </nav>

    <div class="card mb-3 table-card">
      <div class="card-header">
        <div class="row">
          <div class="col-md-6 col-12 d-flex">
            <h3 class="mt-2" v-if="activeTab==='subscriptions'">Subscriptions ({{ number(totalSubs) }})</h3>
            <h3 class="mt-2" v-else-if="activeTab==='invoices'">Upcoming Invoices ({{ number(totalInvoices) }})</h3>
            <h3 class="mt-2" v-else-if="activeTab==='past_invoices'">Past Invoices ({{ number(totalPastInvoices) }})</h3>
            <h3 class="mt-2" v-else>Proposals ({{ number(totalProposals) }})</h3>
          </div>
          <div class="col-md-6 d-none d-md-block">
            <div class="d-flex justify-content-end gap-2">
                <div class="position-relative">
                    <input
                        type="text"
                        :placeholder="activeTab === 'past_invoices' ? 'Search by client or paid by name...' : 'Search by client name...'"
                        v-model="searchKey"
                        @input="debouncedSearch"
                        class="search-box form-control me-1 py-2"
                     aria-label="activeTab ===">
                    <i class="fa fa-search search-placeholder-icon"></i>
                </div>
              <template v-if="activeTab==='subscriptions'">
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle dropdown-toggle-no-btn"
                    type="button"
                    id="subscriptionStatusFilter"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img class="icon" src="/img/icons/avid-icons/filter-funnel-01.svg" alt=""> {{ statusFilterLabel }}
                  </button>
                  <ul class="dropdown-menu dropdown-menu-primary" aria-labelledby="subscriptionStatusFilter">
                    <li>
                      <a
                        class="dropdown-item"
                        :class="{ active: statusFilter === 'all' }"
                        href="#"
                        @click.prevent="setStatusFilter('all')"
                      >All Statuses</a>
                    </li>
                    <li><hr class="dropdown-divider"></li>
                    <li v-for="status in availableStatuses.filter(s => s.value !== 'all')" :key="status.value">
                      <a
                        class="dropdown-item"
                        :class="{ active: statusFilter === status.value }"
                        href="#"
                        @click.prevent="setStatusFilter(status.value)"
                      >{{ status.label }}</a>
                    </li>
                  </ul>
                </div>
                <button class="btn btn-primary" @click.prevent="addSubscription">
                  <i class="fa fa-plus me-1" />Add Subscription
                </button>
              </template>
              <template v-else-if="activeTab==='invoices'">
                <button class="btn btn-primary" @click.prevent="addInvoice">
                  <i class="fa fa-plus me-1" />Add New
                </button>
              </template>
              <template v-else-if="activeTab==='past_invoices'">
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle dropdown-toggle-no-btn"
                    type="button"
                    id="pastInvoiceStatusFilter"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img class="icon" src="/img/icons/avid-icons/filter-funnel-01.svg" alt=""> {{ statusFilterLabel }}
                  </button>
                  <ul class="dropdown-menu dropdown-menu-primary" aria-labelledby="pastInvoiceStatusFilter">
                    <li>
                      <a
                        class="dropdown-item"
                        :class="{ active: statusFilter === 'all' }"
                        href="#"
                        @click.prevent="setStatusFilter('all')"
                      >All Statuses</a>
                    </li>
                    <li><hr class="dropdown-divider"></li>
                    <li v-for="status in availableStatuses.filter(s => s.value !== 'all')" :key="status.value">
                      <a
                        class="dropdown-item"
                        :class="{ active: statusFilter === status.value }"
                        href="#"
                        @click.prevent="setStatusFilter(status.value)"
                      >{{ status.label }}</a>
                    </li>
                  </ul>
                </div>
              </template>
              <template v-else>
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle dropdown-toggle-no-btn"
                    type="button"
                    id="proposalStatusFilter"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img class="icon" src="/img/icons/avid-icons/filter-funnel-01.svg" alt=""> {{ statusFilterLabel }}
                  </button>
                  <ul class="dropdown-menu dropdown-menu-primary" aria-labelledby="proposalStatusFilter">
                    <li>
                      <a
                        class="dropdown-item"
                        :class="{ active: statusFilter === 'all' }"
                        href="#"
                        @click.prevent="setStatusFilter('all')"
                      >All Statuses</a>
                    </li>
                    <li><hr class="dropdown-divider"></li>
                    <li v-for="status in availableStatuses.filter(s => s.value !== 'all')" :key="status.value">
                      <a
                        class="dropdown-item"
                        :class="{ active: statusFilter === status.value }"
                        href="#"
                        @click.prevent="setStatusFilter(status.value)"
                      >{{ status.label }}</a>
                    </li>
                  </ul>
                </div>
                <button class="btn btn-primary" @click.prevent="addProposal">
                  <i class="fa fa-plus me-1" />Add Proposal
                </button>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body p-0">
        <div class="table-width-responsive">
          <table class="table table-with-pagination mb-0">
            <thead>
              <tr class="table-header-row">
                <th v-if="activeTab==='invoices' || activeTab==='past_invoices'">Invoice #</th>
                <th class="sortable" @click.prevent="sortBy('client_name')">
                  Client
                  <i class="fa fa-sort sort-icon" :class="getSortIconClass('client_name')"></i>
                </th>
                <th v-if="activeTab!=='proposals'" class="sortable" @click.prevent="sortBy('paid_by_name')">
                  Paid By
                  <i class="fa fa-sort sort-icon" :class="getSortIconClass('paid_by_name')"></i>
                </th>
                <th v-if="activeTab==='subscriptions'" class="sortable" @click.prevent="sortBy('start_date')">
                  Start Date
                  <i class="fa fa-sort sort-icon" :class="getSortIconClass('start_date')"></i>
                </th>
                <th v-else-if="activeTab==='invoices' || activeTab==='past_invoices'" class="sortable" @click.prevent="sortBy('date')">
                  Billing Date
                  <i class="fa fa-sort sort-icon" :class="getSortIconClass('date')"></i>
                </th>
                <th v-else class="sortable" @click.prevent="sortBy('expiration_date')">
                  Expiration Date
                  <i class="fa fa-sort sort-icon" :class="getSortIconClass('expiration_date')"></i>
                </th>
                <th v-if="activeTab==='subscriptions'" class="sortable" @click.prevent="sortBy('end_date')">
                  End Date
                  <i class="fa fa-sort sort-icon" :class="getSortIconClass('end_date')"></i>
                </th>
                <th v-if="activeTab==='past_invoices'" class="sortable" @click.prevent="sortBy('status')">
                  Status
                  <i class="fa fa-sort sort-icon" :class="getSortIconClass('status')"></i>
                </th>
                <th v-else-if="activeTab==='proposals'" class="sortable" @click.prevent="sortBy('status')">
                  Status
                  <i class="fa fa-sort sort-icon" :class="getSortIconClass('status')"></i>
                </th>
                <th class="sortable" @click.prevent="sortBy('total_amount')">
                  Total Amount
                  <i class="fa fa-sort sort-icon" :class="getSortIconClass('total_amount')"></i>
                </th>
                <th class="sortable" @click.prevent="sortBy('net_amount')">
                  Net Amount
                  <i class="fa fa-sort sort-icon" :class="getSortIconClass('net_amount')"></i>
                </th>
                <th class="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="isLoading">
                <td :colspan="activeTab==='subscriptions' ? 10 : (activeTab==='past_invoices' ? 11 : (activeTab==='invoices' ? 10 : 9))" class="text-center py-3">Loading...</td>
              </tr>
              <tr v-for="s in list_shown" :key="s.id">
                <td v-if="activeTab==='invoices' || activeTab==='past_invoices'">
                  <a v-if="billingSettingsUrl(s)" :href="billingSettingsUrl(s)">{{ s.display_invoice_id || '—' }}</a>
                  <span v-else>{{ s.display_invoice_id || '—' }}</span>
                </td>
                <td>{{ s.client?.name }}</td>
                <td v-if="activeTab!=='proposals'">{{ s.paid_by?.name }}</td>
                <td v-if="activeTab==='subscriptions'">{{ utc_date(s.start_date) }}</td>
                <td v-else-if="activeTab==='invoices' || activeTab==='past_invoices'">{{ utc_date(s.date) }}</td>
                <td v-else>{{ utc_date(s.expiration_date) }}</td>
                <td v-if="activeTab==='subscriptions'">{{ utc_date(s.end_date) }}</td>
                <td v-if="activeTab==='past_invoices'">
                  <span v-if="s.status === 'open' && isPaidByStripe(s)" class="text-danger">Overdue</span>
                  <span v-else>{{ propercase(s.status) }}</span>
                </td>
                <td v-else-if="activeTab==='proposals'">{{ propercase(s.status) }}</td>
                <td>{{ currency(totalAmount(s)) }}</td>
                <td>{{ currency(netAmount(s)) }}</td>
                <td class="text-center" v-if="activeTab==='subscriptions'">
                <div class="dropdown d-flex justify-content-center">
                  <button class="btn btn-none p-2" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                    <img src="/img/icons/avid-icons/dots-vertical.svg" alt="">
                  </button>
                  <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                    <template v-if="s.deleted_at">
                      <a class="dropdown-item" href="#" @click.prevent="restoreSubscription(s)">
                        <img class="icon me-2" src="/img/icons/avid-icons/refresh.svg" alt=""> Restore
                      </a>
                    </template>
                    <template v-else>
                      <a class="dropdown-item" href="#" @click.prevent="editSubscription(s)">
                        <img class="icon me-2" src="/img/icons/avid-icons/edit.svg" alt=""> Edit
                      </a>
                      <a class="dropdown-item" href="#" @click.prevent="viewSubscription(s)">
                        <img class="icon me-2" src="/img/icons/avid-icons/eye.svg" alt=""> View
                      </a>
                    </template>
                  </div>
                </div>
                </td>
                <td class="text-center" v-else-if="activeTab==='invoices'">
                  <div class="dropdown d-flex justify-content-center">
                    <button class="btn btn-none p-2" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                      <img src="/img/icons/avid-icons/dots-vertical.svg" alt="">
                    </button>
                    <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                      <a class="dropdown-item" href="#" @click.prevent="editInvoice(s)">
                        <img class="icon me-2" src="/img/icons/avid-icons/edit.svg" alt=""> Edit
                      </a>
                      <a class="dropdown-item" href="#" @click.prevent="viewInvoice(s)">
                        <img class="icon me-2" src="/img/icons/avid-icons/eye.svg" alt=""> View
                      </a>
                    </div>
                  </div>
                </td>
                <td class="text-center" v-else-if="activeTab==='past_invoices'">
                  <div class="dropdown d-flex justify-content-center">
                    <button class="btn btn-none p-2" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                      <img src="/img/icons/avid-icons/dots-vertical.svg" alt="">
                    </button>
                    <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                      <a v-if="s.status === 'open' && isPaidByStripe(s)" class="dropdown-item" href="#" @click.prevent="processPayment(s)">
                        <img class="icon me-2" src="/img/icons/avid-icons/refresh.svg" alt=""> Process Payment
                      </a>
                      <a class="dropdown-item" href="#" @click.prevent="viewInvoice(s)">
                        <img class="icon me-2" src="/img/icons/avid-icons/eye.svg" alt=""> View Invoice
                      </a>
                      <a class="dropdown-item" href="#" @click.prevent="billingSettingsUrl(s)">
                        <img class="icon me-2" src="/img/icons/avid-icons/setting-2.svg" alt=""> View Settings
                      </a>
                    </div>
                  </div>
                </td>
                <td class="text-center" v-else-if="s.status==='signed'"> 
                  <div class="dropdown d-flex justify-content-center">
                    <button class="btn btn-none p-2" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                      <img src="/img/icons/avid-icons/dots-vertical.svg" alt="">
                    </button>
                    <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                      <a class="dropdown-item" :href="`/api/billing/proposals/${s.id}/executed-pdf`" target="_blank">
                        <img class="icon me-2" src="/img/icons/avid-icons/eye.svg" alt=""> View PDF
                      </a>
                    </div>
                  </div>
                </td>
                <td class="text-center" v-else> 
                  <div class="dropdown d-flex justify-content-center">
                    <button class="btn btn-none p-2" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                      <img src="/img/icons/avid-icons/dots-vertical.svg" alt="">
                    </button>
                    <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                      <a class="dropdown-item" href="#" @click.prevent="editProposal(s)">
                        <img class="icon me-2" src="/img/icons/avid-icons/edit.svg" alt=""> Edit
                      </a>
                      <a class="dropdown-item" :href="s.url ? `/proposal/${s.url}` : `/proposal/${s.paid_by_id}/${s.id}`" target="_blank">
                        <img class="icon me-2" src="/img/icons/avid-icons/eye.svg" alt=""> View
                      </a>
                      <hr class="my-1" v-if="s.status === 'draft'">
                      <a 
                        class="dropdown-item text-danger" 
                        :class="{ 'disabled': s.status !== 'draft' }"
                        href="#" 
                        @click.prevent="s.status === 'draft' ? deleteProposal(s) : null"
                        :style="{ opacity: s.status !== 'draft' ? '0.5' : '1', cursor: s.status !== 'draft' ? 'not-allowed' : 'pointer' }"
                      >
                        <img class="icon red-icon me-2" src="/img/icons/avid-icons/trash.svg" alt=""> Delete
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="!isLoading && list_shown.length === 0">
                <td :colspan="activeTab==='invoices' || activeTab==='past_invoices' ? 11 : 10" class="text-center py-3">No {{ activeTabLabel }} found.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card-footer" v-if="page_count > 1">
        <div class="table-pagination">
          <div class="table-pagination--group d-none d-md-flex">
            <span class="text-muted">Showing {{ item_interval }} of {{ paginationTotal }} {{ activeTabLabel }}</span>
          </div>
          <div class="table-pagination--group d-none d-lg-flex">
            <select class="form-select form-select-sm" v-model="num_per_page" @change="fetchData" aria-label="Num Per Page">
              <option v-for="option in num_per_page_options" :key="option" :value="option">{{ option }} per page</option>
            </select>
          </div>
          <div class="table-pagination--group">
            <button v-if="page_count > 1" class="btn btn-none me-1" @click.prevent="moveToPrevPage()" :disabled="page_index === 0">
              <i class="fa fa-chevron-left"></i>
            </button>
            <div class="d-flex" v-if="page_index_array.length <= 3">
              <button v-for="page in page_index_array" :key="page" class="btn btn-none" :class="{ 'current-page': page === (page_index + 1) }" @click.prevent="moveToPage(page)">
                {{ page }}
              </button>
            </div>
            <div class="d-flex" v-else>
              <button v-for="page in page_index_array.slice(0,2)" :key="page" class="btn btn-none" :class="{ 'current-page': page === (page_index + 1) }" @click.prevent="moveToPage(page)">
                {{ page }}
              </button>
              <button v-if="page_index >= 2 && page_index < page_index_array.length -1" class="btn btn-none current-page">{{ page_index + 1 }}</button>
              <button v-if="page_index < page_index_array.length -2" class="btn btn-none text-nowrap" disabled>...</button>
              <button :class="{ 'current-page': page_index === (page_index_array.length -1) }" class="btn btn-none" @click.prevent="moveToPage(page_index_array.length)">{{ page_index_array.length }}</button>
            </div>
            <button v-if="page_count > 1" class="btn btn-none ms-1" @click.prevent="moveToNextPage()" :disabled="page_index === page_count -1">
              <i class="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import tablePaginationMixin from '../../mixins/table_pagination';
import filters from '../../mixins/filters';
import Swal from 'sweetalert2';
export default {
  name: 'SubscriptionList',
  mixins: [tablePaginationMixin, filters],
  data() {
    return {
      activeTab: this.getDefaultTab(),
      subs: [],
      totalSubs: 0,
      proposals: [],
      totalProposals: 0,
      invoices: [],
      totalInvoices: 0,
      pastInvoices: [],
      totalPastInvoices: 0,
      searchKey: '',
      statusFilter: this.getDefaultStatusFilter(),
      sortKey: this.getDefaultSortKey(),
      sortOrder: this.getDefaultSortOrder(),
      isLoading: false,
    };
  },
  computed: {
    availableStatuses() {
      if (this.activeTab === 'subscriptions') {
        return [
          { value: 'all', label: 'All Statuses' },
          { value: 'active', label: 'Active' },
          { value: 'ended', label: 'Ended' },
          { value: 'deleted', label: 'Deleted' }
        ];
      }
      if (this.activeTab === 'past_invoices') {
        return [
          { value: 'all', label: 'All Statuses' },
          { value: 'open', label: 'Open' },
          { value: 'paid', label: 'Paid' }
        ];
      }
      // Proposals statuses
      return [
        { value: 'all', label: 'All Statuses' },
        { value: 'draft', label: 'Draft' },
        { value: 'sent', label: 'Sent' },
        { value: 'signed', label: 'Signed' },
        { value: 'rejected', label: 'Rejected' },
        { value: 'expired', label: 'Expired' }
      ];
    },
    statusFilterLabel() {
      const selected = this.availableStatuses.find((status) => status.value === this.statusFilter);
      return selected ? selected.label : 'Status';
    },
    list_shown() {
      if (this.activeTab === 'subscriptions') {
        return this.subs;
      }
      if (this.activeTab === 'invoices') {
        return this.invoices;
      }
      if (this.activeTab === 'past_invoices') {
        return this.pastInvoices;
      }
      return this.proposals;
    },
    paginationTotal() {
      if (this.activeTab === 'subscriptions') return this.totalSubs;
      if (this.activeTab === 'invoices') return this.totalInvoices;
      if (this.activeTab === 'past_invoices') return this.totalPastInvoices;
      return this.totalProposals;
    },
    activeTabLabel() {
      if (this.activeTab === 'past_invoices') return 'past invoices';
      return this.activeTab;
    },
  },
  created() {
    this.debouncedSearch = debounce(this.fetchData, 500);
    this.fetchData();
  },
  methods: {
    getDefaultTab() {
      const path = window.location.pathname;
      if (path.endsWith('/proposals')) {
        return 'proposals';
      }
      if (path.endsWith('/subscriptions')) {
        return 'subscriptions';
      }
      if (path.endsWith('/invoices/past')) {
        return 'past_invoices';
      }
      if (path.endsWith('/invoices')) {
        return 'invoices';
      }
      return 'proposals';
    },
    getDefaultSortKey() {
      const path = window.location.pathname;
      if (path.endsWith('/proposals')) {
        return 'expiration_date';
      }
      if (path.endsWith('/subscriptions')) {
        return 'start_date';
      }
      if (path.endsWith('/invoices/past') || path.endsWith('/invoices')) {
        return 'date';
      }
      return 'expiration_date';
    },
    getDefaultSortOrder() {
      const path = window.location.pathname;
      if (path.endsWith('/invoices') && !path.endsWith('/invoices/past')) {
        return 'asc';
      }
      return 'desc';
    },
    getDefaultStatusFilter(tab = null) {
      const targetTab = tab || this.getDefaultTab();
      if (targetTab === 'subscriptions') {
        return 'active';
      }
      if (targetTab === 'proposals') {
        return 'draft';
      }
      if (targetTab === 'past_invoices') {
        return 'all';
      }
      return 'draft';
    },
    async fetchData() {
      this.isLoading = true;
      if (this.activeTab==='subscriptions') {
        await this.fetchSubs();
      } else if (this.activeTab==='invoices') {
        await this.fetchInvoices();
      } else if (this.activeTab==='past_invoices') {
        await this.fetchPastInvoices();
      } else {
        await this.fetchProposals();
      }
      this.isLoading = false;
    },
    async fetchSubs() {
      const perPage = Number(this.num_per_page) || 20;
      const base = '/api/admin/billing/subscriptions'; // keep admin list
      const params = {
        per_page: perPage,
        page: this.page_index + 1,
        sort_key: this.sortKey,
        sort_order: this.sortOrder,
      };
      if (this.searchKey.trim()) params.search = this.searchKey.trim();
      if (this.statusFilter && this.statusFilter !== 'all') params.status = this.statusFilter;
      const { data } = await window.axios.get(base, { params });
      this.subs = data.data;
      this.totalSubs = data.total;
      this.num_per_page = Number(data.per_page ?? perPage);
      this.updateServerPagination(data.total, this.num_per_page);
    },
    async fetchProposals() {
      const perPage = Number(this.num_per_page) || 20;
      const base = '/api/admin/billing/proposals'; // new admin list endpoint
      const params = {
        per_page: perPage,
        page: this.page_index + 1,
        sort_key: this.sortKey,
        sort_order: this.sortOrder,
      };
      if (this.searchKey.trim()) params.search = this.searchKey.trim();
      if (this.statusFilter && this.statusFilter !== 'all') params.status = this.statusFilter;
      const { data } = await window.axios.get(base, { params });
      this.proposals = data.data;
      this.totalProposals = data.total;
      this.num_per_page = Number(data.per_page ?? perPage);
      this.updateServerPagination(data.total, this.num_per_page);
    },
    async fetchInvoices() {
      const perPage = Number(this.num_per_page) || 20;
      const base = '/api/admin/billing/invoices';
      const params = {
        per_page: perPage,
        page: this.page_index + 1,
        sort_key: this.sortKey,
        sort_order: this.sortOrder,
      };
      if (this.searchKey.trim()) params.search = this.searchKey.trim();
      const { data } = await window.axios.get(base, { params });
      this.invoices = data.data;
      this.totalInvoices = data.total;
      this.num_per_page = Number(data.per_page ?? perPage);
      this.updateServerPagination(data.total, this.num_per_page);
    },
    async fetchPastInvoices() {
      const perPage = Number(this.num_per_page) || 20;
      const base = '/api/admin/billing/invoices/past';
      const params = {
        per_page: perPage,
        page: this.page_index + 1,
        sort_key: this.sortKey,
        sort_order: this.sortOrder,
      };
      if (this.searchKey.trim()) params.search = this.searchKey.trim();
      if (this.statusFilter && this.statusFilter !== 'all') params.status = this.statusFilter;
      const { data } = await window.axios.get(base, { params });
      this.pastInvoices = data.data;
      this.totalPastInvoices = data.total;
      this.num_per_page = Number(data.per_page ?? perPage);
      this.updateServerPagination(data.total, this.num_per_page);
    },
    sortBy(key) {
      if (this.sortKey === key) this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      else { this.sortKey = key; this.sortOrder = 'asc'; }
      this.fetchData();
    },
    getSortIconClass(key) {
      if (this.sortKey !== key) return 'fa-sort';
      return this.sortOrder === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc';
    },
    switchTab(tab) {
      if (this.activeTab!==tab) {
        this.activeTab = tab;
        this.page_index = 0;
        this.statusFilter = this.getDefaultStatusFilter(tab);
        this.sortKey = this.getDefaultSortKey();
        this.sortOrder = this.getDefaultSortOrder();
        const tabPaths = {
          proposals: '/admin/proposals',
          subscriptions: '/admin/subscriptions',
          invoices: '/admin/invoices',
          past_invoices: '/admin/invoices/past',
        };
        window.history.replaceState({}, '', tabPaths[tab] || `/admin/${tab}`);
        this.fetchData();
      }
    },
    addSubscription() { window.location.href = '/admin/subscriptions/new'; },
    editSubscription(s) { window.location.href = `/admin/subscriptions/${s.id}`; },
    viewSubscription(s) { window.location.href = `/admin/subscriptions/${s.id}?view=1`; },
    async restoreSubscription(subscription) {
      const confirmed = await Swal.fire({
        title: 'Restore Subscription?',
        text: `Are you sure you want to restore the subscription for ${subscription.client?.name}?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, restore it!',
        cancelButtonText: 'Cancel',
        customClass: {
          popup: 'swal-info'
        }
      });

      if (confirmed.isConfirmed) {
        try {
          await window.axios.post(`/api/billing/subscriptions/${subscription.id}/restore`);
          
          Swal.fire({
            title: 'Restored!',
            text: 'The subscription has been restored successfully.',
            icon: 'success',
            customClass: {
              popup: 'swal-success'
            }
          });

          // Refresh the data
          this.fetchData();
        } catch (error) {
          console.error('Error restoring subscription:', error);
          Swal.fire({
            title: 'Error!',
            text: error.response?.data?.message || 'There was an error restoring the subscription. Please try again.',
            icon: 'error',
            customClass: {
              popup: 'swal-error'
            }
          });
        }
      }
    },
    addProposal() { window.location.href = '/admin/proposals/new'; },
    editProposal(p) { window.location.href = `/admin/proposals/${p.id}`; },
    addInvoice() { window.location.href = '/admin/invoices/new'; },
    editInvoice(i) { window.location.href = `/admin/invoices/${i.id}`; },
    viewInvoice(i) { window.location.href = `/admin/invoices/${i.id}?view=1`; },
    billingSettingsUrl(row) {
      const paidBy = row.paid_by;
      if (!paidBy) return null;
      const type = row.paid_by_type || '';
      // Client: /settings/{url}/billing
      if (type.includes('Client') && paidBy.url) return `/settings/${paidBy.url}/billing`;
      // Agency: /admin/agencies/{id}/billing
      if (type.includes('Agency') && paidBy.id) return `/admin/agencies/${paidBy.id}/billing`;
      return null;
    },
    isPaidByStripe(invoice) {
      const paidBy = invoice.paid_by;
      return paidBy && (paidBy.payment_method === 'stripe' );
    },
    async processPayment(invoice) {
      try {
        const { data } = await window.axios.post(`/api/billing/invoices/${invoice.id}/charge`);
        await Swal.fire({
          title: 'Success',
          text: data.message || 'Payment processed successfully.',
          icon: 'success',
          customClass: { popup: 'swal-success' },
        });
        this.fetchData();
      } catch (err) {
        const msg = err.response?.data?.message || err.message || 'Failed to process payment.';
        await Swal.fire({
          title: 'Error',
          text: msg,
          icon: 'error',
          customClass: { popup: 'swal-error' },
        });
      }
    },
    totalAmount(sub) {
      return sub.line_items?.reduce((acc, li) => acc + Number(li.total_amount || 0), 0) || 0;
    },
    netAmount(sub) {
      return sub.line_items?.reduce((acc, li) => acc + Number(li.net_amount || 0), 0) || 0;
    },
    isWithinThreeDays(date) {
        const today = new Date();
        const expDate = new Date(date);
        const diffTime = expDate - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays <= 3 && diffDays > 0;
    },
    isPast(date) {
        const today = new Date();
        const expDate = new Date(date);
        return expDate < today;
    },
    updateServerPagination(total, perPage = this.num_per_page) {
      const pageSize = Number(perPage) || this.num_per_page;
      this.page_count = Math.ceil(total / pageSize);
      this.page_index_array = Array.from({ length: this.page_count }, (_, i) => i + 1);
      this.updateItemInterval(pageSize);
    },
    updateItemInterval(perPage = this.num_per_page) {
      const pageSize = Number(perPage) || this.num_per_page;
      const from = this.page_index * pageSize + 1;
      let to = (this.page_index + 1) * pageSize;
      const total = this.paginationTotal;
      if (to > total) to = total;
      this.item_interval = `${from} - ${to}`;
    },
    moveToPrevPage() {
      if (this.page_index > 0) {
        this.page_index--;
        this.fetchData();
      }
    },
    moveToPage(page) {
      this.page_index = page - 1;
      this.fetchData();
    },
    moveToNextPage() {
      if (this.page_index < this.page_count - 1) {
        this.page_index++;
        this.fetchData();
      }
    },
    setStatusFilter(status) {
      if (this.statusFilter === status && this.page_index === 0) {
        return;
      }
      this.statusFilter = status;
      this.page_index = 0;
      this.fetchData();
    },
    async deleteProposal(proposal) {
      const confirmed = await Swal.fire({
        title: 'Are you sure?',
        text: `Are you sure you want to delete the proposal for ${proposal.client?.name}? This action cannot be undone.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel',
        customClass: {
          popup: 'swal-warning'
        }
      });

      if (confirmed.isConfirmed) {
        try {
          await window.axios.delete(`/api/billing/proposals/${proposal.id}`);
          
          Swal.fire({
            title: 'Deleted!',
            text: 'The proposal has been deleted successfully.',
            icon: 'success',
            customClass: {
              popup: 'swal-success'
            }
          });

          // Refresh the data
          this.fetchData();
        } catch (error) {
          console.error('Error deleting proposal:', error);
          Swal.fire({
            title: 'Error!',
            text: 'There was an error deleting the proposal. Please try again.',
            icon: 'error',
            customClass: {
              popup: 'swal-error'
            }
          });
        }
      }
    },
  },
  watch: {
    num_per_page() { 
      this.num_per_page = Number(this.num_per_page) || 20;
      this.page_index = 0;
      this.fetchData(); 
    }
  }
};
</script>